import {
  PLACEHOLDER_PATTERN,
  SAMPLE_PLACEHOLDERS,
} from "../config/placeholders";

export interface MessageWarning {
  code: string;
  message: string;
  match?: string;
}
const commonGivenNames =
  /\b(John|Sarah|Mike|Michael|Jessica|David|Emily|James|Jennifer|Robert|Mary|Chris|Christopher|Linda)\b/i;
const dateLike =
  /\b(?:0?[1-9]|1[0-2])[/-](?:0?[1-9]|[12]\d|3[01])[/-](?:20)?\d{2}\b/;
const orderLike =
  /\b(?:order|account|application)\s*(?:#|number|no\.?|id)?\s*[A-Z0-9-]{5,}\b/i;

export function validateSampleMessage(
  value: string,
  brandName = "",
): MessageWarning[] {
  const text = value.replace(PLACEHOLDER_PATTERN, "");
  const warnings: MessageWarning[] = [];
  const name = text.match(commonGivenNames)?.[0];
  if (name && name.toLowerCase() !== brandName.trim().toLowerCase())
    warnings.push({
      code: "possible-name",
      match: name,
      message: `“${name}” looks like a customer name. Use [First Name] unless it is part of your brand.`,
    });
  if (dateLike.test(text))
    warnings.push({
      code: "hardcoded-date",
      message: "A hardcoded date was detected. Consider [Appointment Date].",
    });
  if (orderLike.test(text))
    warnings.push({
      code: "hardcoded-id",
      message:
        "A customer-specific identifier may be present. Consider [Order Number] or [Application Status].",
    });
  return warnings;
}
export function isSupportedPlaceholder(value: string): boolean {
  return (SAMPLE_PLACEHOLDERS as readonly string[]).includes(value);
}
